import React from 'react';

import { getEnv } from "../../../configuration/ConfigExpr"

class FooterDeclaration extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount(){

    }

    componentDidMount(){
    }

    render(){

        let _http = getEnv( process.title, "abtest" );
        let _https = getEnv( process.title, "abtest" );

        _http = _https = "";

        return(
            <div className="footer-declaration">
                <div className="footer-declaration-content">
                    <ul className="footer-declaration-content-center">
                        <li className="footer-declaration-id">
                            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602003121" target="_blank" className="footer-records">沪公网安备 31010602003121号</a>

                            <a href="http://beian.miit.gov.cn" title="中国互联网电子商务诚信示范企业认证书" target="_blank" rel="nofollow">ICP备案序号:沪ICP备05026645号-1</a>

                            <a href="https://ssl1.sephorastatic.cn/wcsfrontend/campaign/campaign_img/2019/02/banner/food_license.jpg" title="食品经营许可证" target="_blank" rel="nofollow">食品经营许可证</a>

                            <a href={ _http + "/content/usage/" } title="网站使用条款" target="_blank" rel="nofollow">网站使用条款</a>

                            <a href={ _http + "/content/declaration/" } title="严正声明" target="_blank" rel="nofollow">严正声明</a>
                        </li>
                        <li className="footer-declaration-info">
                            本网站隶属于丝芙兰（上海）化妆品销售有限公司<span>（<a className="footer-declaration-info-text" target="_blank" href={ "https://s1.sephorastatic.cn/wcsfrontend/campaign/campaign_img/2018/12/banner/business-license_pic.jpg" } title="企业法人营业执照" rel="nofollow">企业法人营业执照</a>）</span>

                            <a className="footer-declaration-info-text" target="_blank" href="https://www.sephora.cn/campaign/prepaidcard20190113/" title="预付卡信息对接唯一标示:310101F5201530100309" rel="nofollow">预付卡信息对接唯一标识 : 310101F5201530100309</a>
                        </li>
                    </ul>
                </div>

            </div>
        )
    }
}

export default FooterDeclaration



// WEBPACK FOOTER //
// ./common/components/Footer/FooterDeclaration.js